<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte Estado Facturas Electrónicas</div>
    <div class="box-container">


      <Filtros :tipo="tipo" :loading="loading" @consultar="getReporteEquipos" @tipo="tipo = $event" />

      <div id="containter-table" class="containter-table">
        <table id="table2" width="100%" class="display nowrap" style="width: 100%">
          <thead>
            <tr>
              <th width="130px">Fecha ELE</th>
              <th width="100px">Consecutivos</th>
              <th class="text-center">Nit</th>
              <th>Cliente</th>
              <th class="text-center">Productos</th>
              <th class="text-center">Precio</th>
              <th width="60px" class="text-center">Impuesto</th>
              <th width="80px" class="text-center">Venta</th>
              <th class="text-center">Código</th>
              <th width="80px" class="text-center">Estado</th>
              <th width="30px" class="text-center">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <Resumen :totalventas="totalventas" :fcantidad="fcantidad" :ftotalimpuestos="ftotalimpuestos"
          :ftotales="ftotales" />
      </div>

      <!-- Modal para mostrar detalle de error -->
      <ModalDetalleError ref="modalError" @reprocesar="reintentarFactura" />


      <div id="ModalCancel" class="modal" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Motivo de Cancelación</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="titles-options">
                ¿Desea cancelar la factura {{ factura_eliminar }}?
              </div>
              <div style="font-size: 10px; text-align: center">
                {{ this.factura_eliminar_uniqueid }} ||
                {{ this.factura_eliminar_remotoid }}
              </div>
              <div style="padding: 8px">
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="01"
                      v-model="opcionSeleccionada" />
                    01-Comprobante emitido con errores con relación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="02"
                      v-model="opcionSeleccionada" />
                    02-Comprobante emitido con errores sin relación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="03"
                      v-model="opcionSeleccionada" />
                    03-No se llevó a cabo la operación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="04"
                      v-model="opcionSeleccionada" />
                    04-Operación nominativa relacionada a la factura global
                  </div>
                </label>
              </div>
              <div style="padding: 8px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td class="left">
                        <button class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                          Cerrar
                        </button>
                      </td>
                      <td class="right">
                        <button class="btn btn-danger" v-if="factura_eliminar_remotoid"
                          @click="enviarCancelacionFactura" :disabled="desabilitarBotonCancelar">
                          Sí, Cancelar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para inactivar factura -->
      <div id="ModalInactivar" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Inactivar Factura</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div style="font-size: 15px; text-align: center;">
                ¿Está seguro que desea inactivar la factura
                <span style="color: #c00">
                  {{ factura_eliminar }}
                </span>
              </div>
              <p style="padding: 20px 20px 0px 20px; font-size: 13px;">
                Al inactivar la factura, confirma que <b>no se encuentra activa en el SAT</b> o <b>nunca se llegó a
                  emitir</b>.<br>
                Esta acción <b>cancelará el consecutivo actual</b> y <b>liberará las ventas asociadas</b> a esta
                factura.<br>
                <b>Esta acción no se puede deshacer.</b>
              </p>
              <p>
                <label class="font-weight-bold small">Observación (motivo de inactivación)</label>
                <textarea v-model="motivoInactivacion" class="form-control" rows="3"
                  placeholder="Describa brevemente el motivo"></textarea>
                <small class="text-muted">Esta observación quedará registrada junto con la inactivación.</small>
              </p>
              <p class="text-danger font-weight-bold" v-if="mensajeInactivacion">
                {{ mensajeInactivacion }}
              </p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="confirmarInactivarFactura">Sí</button>
            </div>
          </div>
        </div>
      </div>


      <!-- Modal cambiar opciones en factura -->
      <div id="ModalOpciones" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Cambiar Opciones de Factura</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <div>Tipo de venta</div>
              <div>
                <select class="form-control" v-model="tipo_venta">
                  <option :key="item._id" :value="item._id" v-for="item in lista_tipo_venta">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>

              <div>Método de pago</div>
              <div>
                <select class="form-control" v-model="metodo_pago">
                  <option :key="item._id" :value="item._id" v-for="item in lista_metodo_pago">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Uso de CFDI</div>
              <div>
                <select class="form-control" v-model="uso_cfdi">
                  <option :key="item._id" :value="item._id" v-for="item in lista_uso_cfdi">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Forma de pago</div>
              <div>
                <select class="form-control" v-model="forma_pago">
                  <option :key="item._id" :value="item._id" v-for="item in lista_forma_pago">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Periodicidad</div>
              <div>
                <select class="form-control" v-model="perioricidad" :disabled="desabilitarPerioricidad">
                  <option :key="item._id" :value="item._id" v-for="item in lista_perioricidad">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>

              <div>
                <div>Observaciones</div>
                <div>
                  <input class="form-control" v-model="observaciones" />
                </div>
              </div>

              <p class="text-danger font-weight-bold" v-if="mensajCambioOpciones">
                {{ mensajCambioOpciones }}
              </p>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="confirmarCambioOpcionesFactura">Sí</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Reenviar Correo -->
      <ModalReenviarCorreo ref="modalCorreo" />

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import FacturadorService from "../Facturador/FacturadorService";

//- componentes
import Filtros from "./components/Filtros.vue";
import Resumen from "./components/Resumen.vue";
import ModalReenviarCorreo from "./components/ModalReenviarCorreo.vue";
import ModalDetalleError from "./components/ModalDetalleError.vue";

//- datatable
import columns from "./datatable/columns.js";
import createdRow from "./datatable/createdRow.js";

//- utils
import getMensajeError from "./utils/errorParser";


export default {
  components: {
    Filtros,
    Resumen,
    ModalReenviarCorreo,
    ModalDetalleError
  },
  data() {
    return {
      GLOBAL,
      reporteService: null,
      facturadorService: null,
      person: null,
      empresa: "",
      cache: false,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      tipo: "1",
      loading: true,
      datatable: null,
      clientes: [],
      cliente: "",
      mensajeError: "",
      factura_eliminar: null,
      factura_eliminar_item: null,
      factura_eliminar_uniqueid: null,
      factura_eliminar_remotoid: null,
      opcionSeleccionada: "",
      desabilitarBotonCancelar: false,
      isCheckedReasignarTercero: false,
      mensajeAnulacion: "",
      motivoInactivacion: "",
      mensajeInactivacion: "",

      lista_metodo_pago: [],
      metodo_pago: null,

      lista_forma_pago: [],
      forma_pago: null,

      lista_uso_cfdi: [],
      uso_cfdi: null,

      lista_tipo_venta: [],
      tipo_venta: null,

      lista_perioricidad: [],
      perioricidad: null,
      desabilitarPerioricidad: false,
      observaciones: "",

      mensajCambioOpciones: "",

      // NUEVO: para saber qué factura está asociada al error del modal
      factura_error_item: null,

      correoDialog: false,
      correoFactura: {
        uniqueid: null,
        nombre: "",
        correo: "",
        historial: []
      }
    };
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    if (GLOBAL.COUNTRY == "MX") {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
    }
    this.empresa = this.person.empresas;
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
    this.facturadorService = new FacturadorService();
    this.reporte = [];
  },

  mounted() {
    this.reporte = [];

    this.initDateInputs();

    const vm = this;

    this.datatable = $("#table2").DataTable({
      data: this.reporte,
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,
      columns: columns(vm),
      createdRow: createdRow(vm),
      dom:
        "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        {
          extend: "copyHtml5",
          text: '<i class="fa-regular fa-clipboard"></i>',
        },
        {
          extend: "excelHtml5",
          text: '<i class="fa-regular fa-file-excel"></i>',
        },
        {
          extend: "csvHtml5",
          text: '<i class="fa-solid fa-file-csv"></i>',
        },
        {
          extend: "pdfHtml5",
          text: '<i class="fa-regular fa-file-pdf"></i>',
        },
      ],
      scrollX: true,
      responsive: false,
      autoWidth: true,
      language: {
        url: "plugins/Spanish.json",
      },
    });

    this.getReporteEquipos();
    this.getCatalogos();
  },

  methods: {

    ymdHM(date, end = false) {
      const pad = n => n.toString().padStart(2, "0");
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());
      return `${y}-${m}-${d} ${end ? "23:59" : "00:00"}`;
    },

    initDateInputs() {
      const now = new Date();
      $("#fechainicio").val(this.ymdHM(now, false));
      $("#fechafin").val(this.ymdHM(now, true));
      $("input[datatype='fecha']").datetimepicker();
    },

    checkReasignarTercero() {
      if (this.isCheckedReasignarTercero) {
        this.opcionSeleccionada = "001-Reasignar Cliente";
      } else {
        this.opcionSeleccionada = "";
      }

      this.mensajeAnulacion = "";
    },

    limpiarCliente() {
      this.cliente = "";
    },




    // Botón del modal: "Borrar este mensaje y reenviar"
    reprocesarError(factura) {
      const uid = factura.uniqueid;
      const $btn = $(`#table2 button.btn-info[data-uniqueid="${uid}"]`);

      this.reintentarFactura(
        factura,
        $btn.length ? $btn[0] : null,
        true
      );
    },

    // reintentarFactura ahora recibe borrarCache (por defecto false)
    reintentarFactura(item, btn, borrarCache = false) {
      if (btn) {
        $(btn).addClass("btn-loading");
        $(btn).attr("disabled", true);
        $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
      }

      var request = {
        uniqueid: item.uniqueid,
      };

      if (borrarCache) {
        request.borrar_cache = true;
      }

      const done = () => {
        if (btn) {
          $(btn).removeClass("btn-loading");
          $(btn).attr("disabled", false);
          $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
        }
        this.getReporteEquipos();
      };

      if (item.documento_id == GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {
        this.reporteService
          .reintentarEnvioFacturaMexico(this.person, request)
          .then(done);
      } else {
        this.reporteService
          .reintentarNotaCreditoMexico(this.person, request)
          .then(done);
      }
    },

    reintentarEnvioFacturaColombia(item, btn) {
      $(btn).html("<i class='fa-solid fa-arrows-rotate fa-spin'></i>");
      $(btn).attr("disabled", true);
      var request = {
        uniqueId: item.uniqueid,
      };
      this.reporteService
        .reintentarEnvioFacturaColombia(this.person, request)
        .then((data) => {
          this.reporteService
            .reintentarEnvioFacturaColombia(this.person, request)
            .then((data) => {
              $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
              $(btn).attr("disabled", false);
              this.getReporteEquipos();
            });
        });
    },

    consultaFactura(item, btn) {
      $(btn).html("<i class='fa-solid fa-arrows-rotate fa-spin'></i>");
      $(btn).attr("disabled", true);
      var request = {
        uniqueid: item.uniqueid,
      };
      this.reporteService
        .reintentarConsultaFactura(this.person, request)
        .then((data) => {
          $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
          $(btn).attr("disabled", false);
          this.getReporteEquipos();
        });
    },

    async showInfo(factura, boton) {
      try {
        const detalle = await new ReporteService().getDetalleErrorFacturaElectronica(this.person, factura.uniqueid);
         console.log("Detalle del error obtenido:", detalle);
        this.$refs.modalError.show(detalle, boton, getMensajeError(detalle));
      } catch (e) {
        console.error(e);
        this.$refs.modalError.show({}, boton, "No fue posible obtener el detalle del error.");
      }
    },

    cancelarFactura(item) {
      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.desabilitarBotonCancelar = false;

      this.factura_eliminar_uniqueid = item.uniqueid;

      if (GLOBAL.COUNTRY == "MX") {

        this.factura_eliminar_remotoid = item.tercero_hasp;
        console.log("Hasp remoto ID para cancelación:", item);


        $("#ModalCancel").modal("show");
      }
    },

    // ModalInactivar
    inactivarFactura(item) {
      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.desabilitarBotonCancelar = false;

      this.factura_eliminar_uniqueid = item.uniqueid;

      if (GLOBAL.COUNTRY == "MX") {
        $("#ModalInactivar").modal("show");
      }
    },

    enviarCancelacionFactura() {
      var valido = "OK";

      if (
        this.opcionSeleccionada == null ||
        this.opcionSeleccionada.trim() == ""
      ) {
        valido = "Debe escribir un motivo de anulación";
      }

      if (this.isCheckedReasignarTercero && this.cliente == "") {
        valido = "Debe seleccionar a un cliente";
      }

      if (valido == "OK") {
        this.mensajeAnulacion = "";
        const request = {
          uniqueId: this.factura_eliminar_uniqueid,
          remotoId: this.factura_eliminar_remotoid,
          cancelacion: this.opcionSeleccionada,
          terceroUnique: "",
        };

        if (this.isCheckedReasignarTercero) {
          request.terceroUnique = this.cliente;
        }

        this.desabilitarBotonCancelar = true;
        this.facturadorService
          .enviarCancelacionFactura(this.person, request)
          .then((data) => {
            $("#ModalCancel").modal("hide");

            this.desabilitarBotonCancelar = false;
            this.item = [];
            this.getReporteEquipos();
            this.factura_eliminar_remotoid = null;
          });
      } else {
        this.mensajeAnulacion = valido;
      }
    },

    confirmarInactivarFactura() {
      var valido = "OK";

      if (
        this.motivoInactivacion == null ||
        this.motivoInactivacion.trim() == ""
      ) {
        valido = "Debe escribir un motivo de anulación";
      }

      if (valido == "OK") {
        this.mensajeAnulacion = "";
        const request = {
          uniqueId: this.factura_eliminar_uniqueid,
          remotoId: this.factura_eliminar_remotoid,
          motivo: this.motivoInactivacion
        };

        this.desabilitarBotonCancelar = true;
        this.facturadorService
          .enviarInactivacionFactura(this.person, request)
          .then((data) => {
            $("#ModalInactivar").modal("hide");

            this.mensajeAnulacion = "";
            this.motivoInactivacion = "";
            this.desabilitarBotonCancelar = false;
            this.item = [];
            this.getReporteEquipos();
            this.factura_eliminar_remotoid = null;

          });

      } else {
        this.mensajeInactivacion = valido;
      }
    },

    getCatalogos() {
      if (this.catalogo == null) {
        this.facturadorService.getCatalogos(this.person).then((data) => {
          var json = data;
          for (const i in json) {
            switch (json[i].tipo) {
              case GLOBAL.CATALOGO_MEXICO.METODO_PAGO:
                this.lista_metodo_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.FORMA_PAGO:
                this.lista_forma_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.USO_CFDI:
                this.lista_uso_cfdi.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.TIPO_VENTA:
                this.lista_tipo_venta.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.PERIORICIDAD:
                this.lista_perioricidad.push(json[i]);
                break;
              default:
                break;
            }
          }
        });
      }
    },

    async getReporteEquipos() {
      this.datatable.page(0).draw(false);
      this.reporte = [];
      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();
      this.loading = true;

      try {
        const data = await this.reporteService.getListaMovimientosDocumentos(
          this.person, fechainicio, fechafin, this.tipo
        );
        this.reporte = Array.isArray(data) ? data : [];

        // Totales compactos
        const agg = this.reporte.reduce((a, r) => ({
          totalimpuestos: a.totalimpuestos + (r.impuesto_total || 0),
          totalCantidad: a.totalCantidad + (r.cantidad || 0),
          totales: a.totales + (r.venta_total || 0),
          totalventas: a.totalventas + 1
        }), { totalimpuestos: 0, totalCantidad: 0, totales: 0, totalventas: 0 });

        Object.assign(this, {
          totalimpuestos: agg.totalimpuestos,
          totalCantidad: agg.totalCantidad,
          totales: agg.totales,
          totalventas: agg.totalventas,
          fcantidad: this.GLOBAL.FORMATO_NUMBER(agg.totalCantidad),
          ftotalimpuestos: this.GLOBAL.FORMATO_MONEY(agg.totalimpuestos),
          ftotales: this.GLOBAL.FORMATO_MONEY(agg.totales),
          fecha_inicio_reporte: fechainicio,
          fecha_final_reporte: fechafin
        });

        // Refrescar DT
        this.datatable.clear().rows.add(this.reporte).draw();
      } finally {
        this.loading = false;
      }
    },

    // ModalOpciones
    opcionesFactura(item) {

      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.factura_eliminar_uniqueid = item.uniqueid;
      this.factura_eliminar_item = item;

      this.metodo_pago = item.atributos.metodo_pago;
      this.forma_pago = item.atributos.forma_pago;
      this.uso_cfdi = item.atributos.uso_cfdi;
      this.tipo_venta = item.atributos.tipo_venta;
      this.perioricidad = item.atributos.perioricidad;
      this.observaciones = item.atributos.observaciones;

      if (item.tercero_nit != "XAXX010101000") {
        this.desabilitarPerioricidad = true;
      } else {
        this.desabilitarPerioricidad = false;
      }

      if (GLOBAL.COUNTRY == "MX") {
        $("#ModalOpciones").modal("show");
      }
    },

    confirmarCambioOpcionesFactura() {
      // Validación individual de cada campo
      if (!this.metodo_pago || this.metodo_pago === "") {
        this.mensajCambioOpciones = "Debe seleccionar el método de pago.";
        return;
      }
      if (!this.forma_pago || this.forma_pago === "") {
        this.mensajCambioOpciones = "Debe seleccionar la forma de pago.";
        return;
      }
      if (!this.uso_cfdi || this.uso_cfdi === "") {
        this.mensajCambioOpciones = "Debe seleccionar el uso de CFDI.";
        return;
      }
      if (!this.tipo_venta || this.tipo_venta === "") {
        this.mensajCambioOpciones = "Debe seleccionar el tipo de venta.";
        return;
      }
      if (this.factura_eliminar_item.tercero_nit == "XAXX010101000") {
        if (!this.perioricidad || this.perioricidad === "") {
          this.mensajCambioOpciones = "Debe seleccionar la periodicidad.";
          return;
        }
      }
      // Si todo está correcto, limpiar mensaje y continuar
      this.mensajCambioOpciones = "";

      const request = {
        uniqueId: this.factura_eliminar_uniqueid,
        metodo_pago: this.metodo_pago,
        forma_pago: this.forma_pago,
        uso_cfdi: this.uso_cfdi,
        tipo_venta: this.tipo_venta,
        perioricidad: this.perioricidad,
        observaciones: this.observaciones,
        atributos: this.factura_eliminar_item.atributos
      };

      this.desabilitarBotonCancelar = true;
      this.facturadorService
        .enviarCambioOpcionesFactura(this.person, request)
        .then((data) => {
          $("#ModalOpciones").modal("hide");
          this.mensajCambioOpciones = "";
          this.item = [];
          this.getReporteEquipos();
        });
    },

    reenviarCorreo(factura) {
      this.$refs.modalCorreo.show(factura);
    }

  },
};
</script>




<style scope>
/* ANIMACIÓN DEL BOTÓN DE REPROCESO */
.btn-loading {
  pointer-events: none !important;
  opacity: 0.9;
}

.btn-loading i {
  animation: spinPulse 1s infinite;
  display: inline-block;
}

.btn-white {
  background-color: #406b00;
  color: #ffffff;
  border: 1px solid #cccccc;
}

@keyframes spinPulse {
  0% {
    transform: rotate(0deg) scale(1);
  }

  100% {
    transform: rotate(360deg) scale(1);
  }
}
</style>